import http from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
export const rpcClient = createRpcClientV2({
  hubHttpClient: http
});